<div class="container">
  <h2 class="page-title">
    <span class="icon"><i class="fas fa-clipboard-list"></i></span
    >{{ "DoMerge.Search.Title" | translate }}
  </h2>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="block">
            <div class="p-fluid formgrid grid">
              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.DoNo" | translate }}</label>
                <p-chips
                  formControlName="doNos"
                  separator=","
                  (onAdd)="chipsAdd($event, 'doNos')"
                >
                </p-chips>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{
                  "DoMerge.Search.LetterHeadOrgId" | translate
                }}</label>
                <p-dropdown
                  formControlName="letterHeadOrgId"
                  [showClear]="true"
                  [filter]="true"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="letterHeadOrgIdOptions"
                  appendTo="body"
                ></p-dropdown>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.ConsigneeKey" | translate }}</label>
                <laas-customer-dropdown
                  formControlName="consigneeKey"
                  [showToggleAll]="false"
                  [isMultiple]="true"
                  [showLabel]="false"
                  (onOptionDataChange)="getShipToOptionsByConsigneeKey()"
                ></laas-customer-dropdown>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.ShipTo" | translate }}</label>
                <p-multiSelect
                  [filter]="true"
                  formControlName="shipTo"
                  [options]="shipToOptions"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  appendTo="body"
                ></p-multiSelect>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.Creater" | translate }}</label>
                <p-multiSelect
                  [options]="createrOptions"
                  appendTo="body"
                  formControlName="creater"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [filter]="true"
                  filterBy="label"
                  [showToggleAll]="false"
                  [virtualScroll]="true"
                  [itemSize]="30"
                >
                </p-multiSelect>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.Sales" | translate }}</label>
                <p-multiSelect
                  [options]="salesOptions"
                  appendTo="body"
                  formControlName="sales"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [filter]="true"
                  filterBy="label"
                  [showToggleAll]="false"
                  [virtualScroll]="true"
                  [itemSize]="30"
                >
                </p-multiSelect>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.DoStatus" | translate }}</label>
                <p-multiSelect
                  formControlName="doStatus"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [options]="doStatusOptions"
                  appendTo="body"
                ></p-multiSelect>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.Facility" | translate }}</label>
                <laas-facility-dropdown
                  formControlName="facility"
                  [isSingle]="true">
                </laas-facility-dropdown>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{
                  "DoMerge.Search.DeliveryCategory" | translate
                }}</label>
                <p-dropdown
                  formControlName="deliveryCategory"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [showClear]="true"
                  [options]="deliveryCategoryOptions"
                ></p-dropdown>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.DropType" | translate }}</label>
                <p-dropdown
                  formControlName="dropType"
                  [options]="commonOptions"
                  [showClear]="true"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                >
                </p-dropdown>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.HasBooking" | translate }}</label>
                <p-dropdown
                  formControlName="hasBooking"
                  [options]="hasBookingOptions"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                >
                </p-dropdown>
              </div>

              <div class="col-12 md:col-6 lg:col-4 laas-calendar">
                <laas-calendar
                  #etdDt
                  [title]="'DoMerge.MainTable.ETD'"
                  [requiredStar]="!searchForm.get('doNos')?.value?.length"
                  [defaultDate]="defaultEtdDt"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  [monthRange]="1"
                  [minDate]="etdMinDate"
                  (onDateChange)="dateOnChange($event, 'etdDt')"
                >
                </laas-calendar>
              </div>

              <div class="col-12 md:col-6 lg:col-4 mb-3">
                <label>{{ "DoMerge.Search.OrderQueryScope" | translate }}</label>
                <div class="formgroup-inline mt-2">
                  <div class="field-radiobutton">
                    <p-radioButton
                      formControlName="orderQueryScope"
                      [value]="OrderQueryScopeEnum.personal"
                      label="{{ 'DoMerge.Search.PersonalOrder' | translate }}"
                    ></p-radioButton>
                  </div>
                  <div class="field-radiobutton">
                    <p-radioButton
                      formControlName="orderQueryScope"
                      [value]="OrderQueryScopeEnum.all"
                      label="{{ 'DoMerge.Search.All' | translate }}"
                    ></p-radioButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Search' | translate }}"
                (click)="searchClickBtn($event)"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Reset' | translate }}"
                (click)="resetClickBtn($event)"
                class="p-button-secondary"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
  </p-card>

  <p-table
    #doMergeTable
    laasDataTableSetting
    [value]="results"
    (setPageSize)="setPageSize($event)"
    [scrollable]="true"
    scrollHeight="500px"
    [reorderableColumns]="true"
    [resizableColumns]="true"
    [columnDefaultWidth]="285"
    [selectable]="true"
    [totalRecords]="pageInfo.totalRecords"
    (onPage)="tablePageChange($event)"
    (onSort)="tableSort($event)"
    [rowsPerPageOptions]="[5, 10, 20, 50]"
    [showCurrentPageReport]="true"
    [paginator]="true"
    [rows]="5"
    [lazy]="true"
    [loading]="isLoading"
    dataKey="doNo"
    selectionMode="single"
    [(selection)]="selectedRows"
    editMode="row"
    class="edittable"
    currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
    styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
    [defaultColumns]="dataTableColumns"
    [tableKey]="preferenceKey"
  >
    <ng-template pTemplate="caption">
      <laas-table-column-toggle
        [optionsColumn]="dataTableColumns"
        [dataTable]="doMergeTable"
      >
      </laas-table-column-toggle>
      <button
        pButton
        type="button"
        label="{{ 'NoEvidenceCheck.Button.EditOrView' | translate }}"
        icon="fas fa-pen"
        class="p-button-warning p-button-raised ml-2"
        (click)="switchEditMode()"
        style="color: white"
      ></button>
      <button
        pButton
        type="button"
        label="{{ 'Common.Button.Save' | translate }}"
        (click)="saveBtnClick()"
        [disabled]="!editMode"
        icon="fas fa-save"
        class="p-button-raised ml-2"
      ></button>
      <button
        pButton
        type="button"
        label="{{ 'Common.Button.Restore' | translate }}"
        icon="fas fa-sync-alt"
        [disabled]="!editMode"
        (click)="resetTableValue()"
        class="p-button-secondary p-button-raised ml-2"
      ></button>

      <!-- 勾選 DO 之出貨合計 -->
      <div class="font-bold block mt-3">
        {{ "DOQuery.Form.Title.TotalCartonCnt" | translate }}：{{
          summary.cartonCnt
        }}
        {{ "DOQuery.Form.Title.NetWeight" | translate }}：{{
          summary.totalNetWeight
        }}
        {{ "DOQuery.Form.Title.GrossWeight" | translate }}：{{
          summary.totalGrossWeight
        }}
        {{ "DOQuery.Form.Title.VolumeWeight" | translate }}：{{
          summary.volumeWeight
        }}
        {{ "DOQuery.Form.Title.Cbm" | translate }}：{{ summary.cbm }}
        {{ "DOQuery.Form.Title.Pieces" | translate }}：{{ summary.pieces }}
        <ng-container *ngIf="isSameCurrencyCode">
          {{ "DOQuery.Form.Title.Price" | translate }}({{
            summary.currencyCode
          }})：{{ summary.price }}
        </ng-container>
        <ng-container *ngIf="!isSameCurrencyCode">
          {{ "DOQuery.Form.Title.Price" | translate }}：{{
            "DOQuery.Form.Title.CantShowCurrencyCode" | translate
          }}
        </ng-container>
        {{ "DoMerge.Summary.ForReference" | translate }}
        <i
          *ngIf="hasMissing"
          class="pi pi-exclamation-circle ml-2"
          style="color: #d32f2f"
          [pTooltip]="missingTooltip"
          [escape]="false"
          tooltipPosition="top"
          tooltipStyleClass="missing-info-tooltip"
        ></i>
      </div>
    </ng-template>

    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col style="width: 3vw" />
        <col *ngFor="let col of columns" />
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>
          <p-checkbox
            [(ngModel)]="headerChecked"
            [binary]="true"
            (onChange)="selectAllOrUnSelectAll($event)"
          ></p-checkbox>
        </th>
        <th
          [pSortableColumn]="col.field"
          *ngFor="let col of columns"
          pResizableColumn
          pReorderableColumn
          [attr.field]="col.field"
        >
          {{ col.header | translate }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template
      pTemplate="body"
      let-rowData
      let-columns="columns"
      let-rowIndex="rowIndex"
    >
      <tr
        [pSelectableRow]="rowData"
        [pEditableRow]="rowData"
        (click)="OnRowClick(rowData)"
      >
        <td>
          <p-checkbox
            *ngIf="rowData.canMerge"
            [value]="rowData"
            [(ngModel)]="selectedRowsWithCheckBox"
            (onChange)="onSelectionChange()"
          ></p-checkbox>
        </td>

        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'canMergeStatus'">
              <span *ngIf="rowData.canMerge; else cannotMergeTpl" style="color: #22c55e; white-space: nowrap;">
                <i class="fas fa-check"></i> {{ "DoMerge.CanMerge" | translate }}
              </span>
              <ng-template #cannotMergeTpl>
                <a class="cannot-merge-link"
                (click)="openBlockDetailDialog(rowData); $event.stopPropagation()" >
                <i class="pi pi-exclamation-triangle cannot-merge-icon"></i> {{ "DoMerge.CannotMerge" | translate }}
                </a>
              </ng-template>
            </ng-container>

            <p-cellEditor *ngSwitchCase="'taskCode'">
              <ng-template pTemplate="input">
                <p-dropdown
                  [filter]="true"
                  [showClear]="false"
                  placeholder="{{ 'Common.DropDown.Select' | translate }}"
                  [options]="MergeTaskCodeOptions"
                  appendTo="body"
                  [(ngModel)]="rowData[col.field]"
                  class="p-fluid"
                  (onChange)="taskCodeOptionCahange()"
                >
                </p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : this.MergeTaskCodeOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-template>
            </p-cellEditor>

            <ng-container *ngSwitchCase="'taskValue'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'doStatus'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : doStatusOptions }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'letterHeadOrgId'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | optionsMapping : letterHeadOrgIdOptions
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'shipCorp'">
              <div class="overflow-text">
                {{
                  rowData[col.field] | optionsMapping : letterHeadOrgIdOptions
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'consigneeKey'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping : consigneeKeyOptionsMapping
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'isDropRemark'">
              <div class="overflow-text">
                {{
                  rowData[col.field]?.toString() | optionsMapping : dropOptions
                }}
              </div>
            </ng-container>

            <p-cellEditor *ngSwitchCase="'assignForwarder'">
              <ng-template pTemplate="input">
                <p-dropdown
                  [filter]="true"
                  [showClear]="false"
                  placeholder="{{ 'Common.DropDown.Select' | translate }}"
                  (onClick)="filterForwarderOptionsByDo(rowData)"
                  [options]="filterForwarderOptions"
                  appendTo="body"
                  [(ngModel)]="rowData[col.field]"
                  class="p-fluid"
                >
                </p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : forwarderOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-template>
            </p-cellEditor>

            <ng-container *ngSwitchDefault>
              <ng-container [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | date : "yyyy-MM-dd HH:mm"
                        | replaceNullWith : "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith : "-" }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="dataTableColumns.length + 1">
          {{ "Common.Table.NoData" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="mt-2 text-center">
    <button
      pButton
      pRipple
      label="{{ 'DoMerge.Footer.Merge' | translate }}"
      [disabled]="
        (this.selectedRowsWithCheckBox.length == 0 && !editMode) || editMode
      "
      *ngIf="displayActionBtn('Merge')"
      (click)="mergeDos($event)"
    ></button>

    <button
      pButton
      pRipple
      label="{{ 'DoMerge.Footer.Import' | translate }}"
      class="ml-2"
      [disabled]="
        (this.selectedRowsWithCheckBox.length == 0 && !editMode) || editMode
      "
      *ngIf="displayActionBtn('Import')"
      (click)="importDos($event)"
    ></button>
  </div>

  <p-dialog
  [(visible)]="isShowBlockDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [style]="{ width: '760px' }"
  styleClass="merge-block-dialog"
  (onHide)="blockDetail = null"
  >

    <ng-template pTemplate="header">
      <div class="block-dialog-header">
        <i class="pi pi-exclamation-triangle warning-icon"></i>
        <span>{{ "DoMerge.BlockDialog.Title" | translate }}</span>
      </div>
    </ng-template>

    <div *ngIf="blockDetail" class="block-dialog-body">

      <!-- DO資訊 -->
      <div class="do-info">
        <div class="info-tag"> {{ 'DoMerge.Search.DoNo' | translate }} : {{ blockDetail.doNo }} </div>
        <div class="info-tag"> {{ 'DoMerge.Search.Facility' | translate }} : {{ blockDetail?.facility | replaceNullWith : "-" }} </div>
      </div>

      <div class="merge-card" *ngIf="hasBlockReason('MRG0001') || blockDetail.bookingInfos?.length">
        <div class="reason-section">
          <div class="merge-title reason-title">
            {{ "DoMerge.BlockDialog.Reasons" | translate }}
          </div>

          <div class="reason-list">
            <div class="reason-item">
              <span>{{ getBlockReasonTranslationKey('MRG0001') | translate }}</span>
            </div>
          </div>
        </div>

        <hr
          class="merge-divider"
          *ngIf="blockDetail.bookingInfos?.length">

        <div class="booking-section" *ngIf="blockDetail.bookingInfos?.length">
          <div class="merge-title booking-title">
            {{ "DoMerge.BlockDialog.BookingInfo" | translate }}
          </div>

          <div class="booking-detail-grid" *ngFor="let info of blockDetail.bookingInfos">
            <div class="booking-detail-item">
              <span> {{ "DoMerge.BlockDialog.BookingNo" | translate }} </span>
              <b> {{ info.bookingNo | replaceNullWith:'-' }} </b>
            </div>

            <div class="booking-detail-item">
              <span> {{ "DoMerge.BlockDialog.CarTrip" | translate }} </span>
              <b> {{ info.carTrip | replaceNullWith:'-' }} </b>
            </div>

            <div class="booking-detail-item forwarder-detail-item">
              <span> {{ "DoMerge.BlockDialog.BookingForwarder" | translate }} </span>
              <b> {{ getBookingForwarderDisplay(info) | replaceNullWith:'-' }} </b>
            </div>

            <div class="booking-detail-item">
              <span> {{ "DoMerge.BlockDialog.DeliveryType" | translate }} </span>
              <b> {{ info.deliveryType | replaceNullWith:'-' }} </b>
            </div>
          </div>
        </div>
      </div>

      <div class="merge-card" *ngIf="hasBlockReason('MRG0004') || blockDetail.mergeInfos?.length">
        <div class="reason-section">
          <div class="merge-title reason-title">
            {{ "DoMerge.BlockDialog.Reasons" | translate }}
          </div>

          <div class="reason-list">
            <div class="reason-item">
              <span>{{ getBlockReasonTranslationKey('MRG0004') | translate }}</span>
            </div>
          </div>
        </div>

        <hr
          class="merge-divider"
          *ngIf="blockDetail.mergeInfos?.length">

        <div class="booking-section" *ngIf="blockDetail.mergeInfos?.length">
          <div class="merge-title booking-title">
            {{ "DoMerge.BlockDialog.MergeInfo" | translate }}
          </div>

          <div class="booking-detail-grid merge-detail-grid" *ngFor="let info of blockDetail.mergeInfos">
            <div class="booking-detail-item">
              <span> {{ "DoMerge.BlockDialog.MergeKey" | translate }} </span>
              <b> {{ info.mergeKey | replaceNullWith:'-' }} </b>
            </div>
          </div>
        </div>
      </div>

      <div class="merge-card" *ngIf="getOtherBlockReasonCodes().length">
        <div class="reason-section">
          <div class="merge-title reason-title">
            {{ "DoMerge.BlockDialog.Reasons" | translate }}
          </div>

          <div class="reason-list">
            <div class="reason-item" *ngFor="let reasonCode of getOtherBlockReasonCodes()">
              <span>{{ getBlockReasonTranslationKey(reasonCode) | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <div class="contact-row" *ngIf="hasPrimaryContactEmail()">
          <span class="contact-label"> {{ "DoMerge.BlockDialog.ContactWindow" | translate }} : </span>
          <button
            pButton
            type="button"
            class="contact-btn primary-contact-btn"
            [disabled]="!hasPrimaryContactEmail()"
            (click)="contactPrimaryWindow()"
          >
            <i class="pi pi-user contact-btn-icon"></i>
            <span class="contact-btn-text">{{ "DoMerge.BlockDialog.ContactButton" | translate }}</span>
            <span class="contact-btn-name" *ngIf="shouldShowContactNames(getPrimaryContacts())">{{ getContactNames(getPrimaryContacts()) }}</span>
          </button>
        </div>

        <div class="contact-row" *ngIf="hasProxyContactEmail()">
          <span class="contact-label"> {{ "DoMerge.BlockDialog.ProxyContactWindow" | translate }} : </span>
          <button
            pButton
            type="button"
            class="contact-btn proxy-contact-btn"
            [disabled]="!hasProxyContactEmail()"
            (click)="contactProxyWindow()"
          >
            <i class="pi pi-users contact-btn-icon"></i>
            <span class="contact-btn-text">{{ "DoMerge.BlockDialog.ProxyContactButton" | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
